import { createSidebarObservable } from './sidebar';
import { createLinearModelObservable } from './linearModel';
import { createSamplingDistributionsObservable } from './samplingDistributions';

export const sidebar = createSidebarObservable();
export const linearModel = createLinearModelObservable();
export const samplingDistributions = createSamplingDistributionsObservable();
